import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "calculation-overlay" }
const _hoisted_2 = { class: "calculation-overlay-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "calculation-overlay-steps" }
const _hoisted_5 = { class: "calculation-step-icon" }
const _hoisted_6 = { class: "fas fa-check-circle text-success" }
const _hoisted_7 = { class: "spinner-border spinner-border-sm text-primary" }
const _hoisted_8 = { class: "calculation-step-icon" }
const _hoisted_9 = { class: "fas fa-check-circle text-success" }
const _hoisted_10 = { class: "spinner-border spinner-border-sm text-primary" }
const _hoisted_11 = { class: "fas fa-circle text-muted calculation-step-pending-icon" }
const _hoisted_12 = { class: "calculation-step-icon" }
const _hoisted_13 = { class: "fas fa-check-circle text-success" }
const _hoisted_14 = { class: "spinner-border spinner-border-sm text-primary" }
const _hoisted_15 = { class: "fas fa-circle text-muted calculation-step-pending-icon" }
const _hoisted_16 = { class: "calculation-overlay-footer" }
const _hoisted_17 = { class: "calculation-elapsed" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "d-flex flex-column gap-2" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "spinner-border spinner-border-sm me-1" }
const _hoisted_22 = { class: "fas fa-redo me-1" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.failed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "calculation-overlay-icon" }, [
              _createElementVNode("div", {
                class: "spinner-border text-primary calculation-spinner",
                role: "status"
              })
            ], -1)),
            _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-center mb-1" }, "Připravujeme váš odhad", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-center text-muted mb-4" }, "Prosím vyčkejte, probíhá automatický výpočet", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["calculation-step", _ctx.stepClass(_ctx.stepSendData, 0)])
              }, [
                _createElementVNode("span", _hoisted_5, [
                  _withDirectives(_createElementVNode("i", _hoisted_6, null, 512), [
                    [_vShow, _ctx.elapsedSeconds >= _ctx.stepSendData]
                  ]),
                  _withDirectives(_createElementVNode("span", _hoisted_7, null, 512), [
                    [_vShow, _ctx.elapsedSeconds < _ctx.stepSendData]
                  ])
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "calculation-step-label" }, "Odesílání dat na server"),
                  _createElementVNode("div", { class: "calculation-step-description" }, "Ukládání parametrů odhadu")
                ], -1))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["calculation-step", _ctx.stepClass(_ctx.stepEstateSelection, _ctx.stepSendData)])
              }, [
                _createElementVNode("span", _hoisted_8, [
                  _withDirectives(_createElementVNode("i", _hoisted_9, null, 512), [
                    [_vShow, _ctx.elapsedSeconds >= _ctx.stepEstateSelection]
                  ]),
                  _withDirectives(_createElementVNode("span", _hoisted_10, null, 512), [
                    [_vShow, _ctx.elapsedSeconds >= _ctx.stepSendData && _ctx.elapsedSeconds < _ctx.stepEstateSelection]
                  ]),
                  _withDirectives(_createElementVNode("i", _hoisted_11, null, 512), [
                    [_vShow, _ctx.elapsedSeconds < _ctx.stepSendData]
                  ])
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "calculation-step-label" }, "Výběr srovnávacích nemovitostí"),
                  _createElementVNode("div", { class: "calculation-step-description" }, "Vyhledávání a analýza podobných nemovitostí v okolí")
                ], -1))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["calculation-step", _ctx.stepClass(_ctx.stepAnalysis, _ctx.stepEstateSelection)])
              }, [
                _createElementVNode("span", _hoisted_12, [
                  _withDirectives(_createElementVNode("i", _hoisted_13, null, 512), [
                    [_vShow, _ctx.elapsedSeconds >= _ctx.stepAnalysis]
                  ]),
                  _withDirectives(_createElementVNode("span", _hoisted_14, null, 512), [
                    [_vShow, _ctx.elapsedSeconds >= _ctx.stepEstateSelection && _ctx.elapsedSeconds < _ctx.stepAnalysis]
                  ]),
                  _withDirectives(_createElementVNode("i", _hoisted_15, null, 512), [
                    [_vShow, _ctx.elapsedSeconds < _ctx.stepEstateSelection]
                  ])
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "calculation-step-label" }, "Analýza a výpočet odhadu"),
                  _createElementVNode("div", { class: "calculation-step-description" }, "Porovnání parametrů a stanovení ceny")
                ], -1))
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-clock me-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.formattedElapsedTime), 1)
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "calculation-estimate" }, [
                _createTextVNode(" Výpočet obvykle trvá 1–2 minuty."),
                _createElementVNode("br"),
                _createTextVNode(" Nezavírejte prosím tuto stránku. ")
              ], -1))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "calculation-overlay-icon" }, [
              _createElementVNode("i", { class: "fas fa-exclamation-triangle text-warning calculation-failed-icon" })
            ], -1)),
            _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "text-center mb-1" }, "Automatický výběr nemovitostí selhal", -1)),
            _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-center text-muted mb-4" }, " AI asistent nebyl schopen vybrat srovnávací nemovitosti. Můžete to zkusit znovu, nebo pokračovat bez AI výběru. ", -1)),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry'))),
                disabled: _ctx.retrying
              }, [
                _withDirectives(_createElementVNode("span", _hoisted_21, null, 512), [
                  [_vShow, _ctx.retrying]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_22, null, 512), [
                  [_vShow, !_ctx.retrying]
                ]),
                _cache[11] || (_cache[11] = _createTextVNode(" Zkusit znovu s AI ", -1))
              ], 8, _hoisted_20),
              _createElementVNode("button", {
                class: "btn btn-outline-secondary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('calculate-without-llm'))),
                disabled: _ctx.retrying
              }, [...(_cache[12] || (_cache[12] = [
                _createElementVNode("i", { class: "fas fa-calculator me-1" }, null, -1),
                _createTextVNode(" Vypočítat bez AI asistenta ", -1)
              ]))], 8, _hoisted_23),
              _createElementVNode("button", {
                class: "btn btn-link text-muted",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
                disabled: _ctx.retrying
              }, " Zavřít ", 8, _hoisted_24)
            ])
          ]))
    ])
  ]))
}